import { motion } from "framer-motion";

export const WHATSAPP_URL =
  "https://wa.me/5551991918413?text=Ol%C3%A1%2C%20gostaria%20de%20um%20diagn%C3%B3stico%20para%20o%20meu%20celular%20na%20Pressi%20Celulares.";
export const PHONE_TEL = "tel:+5551991918413";
export const PHONE_DISPLAY = "(51) 99191-8413";
export const WHATSAPP_DISPLAY = "(51) 99191-8413";
export const MAPS_URL =
  "https://www.google.com/maps/search/?api=1&query=Av.+S%C3%A3o+Borja%2C+412%2C+S%C3%A3o+Leopoldo%2C+RS";

export const whatsappFor = (service) =>
  `https://wa.me/5551991918413?text=${encodeURIComponent(
    `Olá, preciso de um orçamento para: ${service}.`
  )}`;

export const LogoMark = ({ size = 36 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="inline-block shrink-0"
  >
    <rect width="36" height="36" rx="9" fill="#99BA4B" />
    <path d="M15.6 8.6a3.4 3.4 0 0 1 4.8 0" stroke="#FFFFFF" strokeWidth="1.7" strokeLinecap="round" />
    <path d="M13.2 6.2a6.8 6.8 0 0 1 9.6 0" stroke="#FFFFFF" strokeWidth="1.7" strokeLinecap="round" />
    <rect x="12" y="12.5" width="12" height="17" rx="3" stroke="#3E4B53" strokeWidth="2.1" />
    <circle cx="18" cy="26" r="1.5" fill="#3E4B53" />
  </svg>
);

export const BrandLogo = () => (
  <span className="flex items-center" data-testid="nav-brand-logo">
    <img src="/logo-pressi.png" alt="Pressi Celulares" className="h-16 w-auto" />
  </span>
);

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.75, delay, ease: [0.16, 1, 0.3, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ overline, title, subtitle }) => (
  <div className="max-w-3xl">
    <Reveal>
      <p className="font-mono-tech text-xs tracking-[0.25em] uppercase text-[#99BA4B] mb-4">
        {overline}
      </p>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl tracking-tight leading-snug text-white">
        {title}
      </h2>
    </Reveal>
    {subtitle && (
      <Reveal delay={0.16}>
        <p className="mt-4 text-base leading-relaxed text-zinc-300">{subtitle}</p>
      </Reveal>
    )}
  </div>
);
